import { toLower } from "lodash"

Controller.$inject = ['userServer', '$state', 'userProfile', 'applicationInfo', 'httpUnauthenticatedInterceptorService', "$window", "$location"]
function Controller(userServer, $state, userProfile, applicationInfo, httpUnauthenticatedInterceptorService, $window, $location) {
  var vm = this

  vm.RememberMe = false
  vm.Username = ''
  vm.Password = ''
  vm.Login = Login
  vm.hasAuthenticationProvider = hasAuthenticationProvider
  vm.authProviderCount = applicationInfo.appInfo.AuthenticationProviders.length

  function hasAuthenticationProvider(name) {
    return applicationInfo.hasAuthenticationProvider(name)
  }

  function Login() {
    userServer
      .login(vm.Username, vm.Password, vm.RememberMe)
      .then(function (profile) {
        vm.Error = ''

        userProfile.initialize(profile)
        httpUnauthenticatedInterceptorService.openLoginInNewWindow = true

        const { closeAfterLogin } = $location.search()

        if(toLower(closeAfterLogin) === 'true') {
          $window.close()
          return
        }

        var targetState = vm.returnState

        if (targetState) {
          $state.go(targetState.name, targetState.params)
        }
        else {
          $state.go('main.machines.grid')
        }
      })
      .catch(function (errorMessage) {
        vm.Password = ''
        vm.Error = errorMessage
      })
  }
}

export default Controller